// eslint-disable-next-line import/no-extraneous-dependencies
import React, {
    HTMLProps,
    ReactElement,
    useState,
} from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { CSS } from "@dnd-kit/utilities";
// eslint-disable-next-line import/no-extraneous-dependencies
import { useSortable } from "@dnd-kit/sortable";
import { Resizable, ResizableProps } from "react-resizable";
// import Resizable, { ResizableProps } from "../../resizable/Resizable";
import { Direction, ResizeHandle } from "../../resizable/Resizable";
import { SortableItemStateContext } from "./SortableItem";

export interface SortableResizableItemProps {
    item: {id: string},
    shouldDragWholeElement?: boolean;
    isEnabled?: boolean;
    axis?: "x" | "y" | "both";
    direction: Direction
}

const SortableResizableItem = React.forwardRef((
    args: SortableResizableItemProps & Omit<ResizableProps, "width" | "height"> & HTMLProps<HTMLElement>,
    ref: React.ForwardedRef<HTMLElement>,
): ReactElement => {
    const {
        children,
        item,
        shouldDragWholeElement,
        isEnabled,
        style,
        direction,
        className,
        ...rest
    } = args;

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        setActivatorNodeRef,
    } = useSortable({ id: item.id, data: item, disabled: !isEnabled });

    const [size, setSize] = useState({ width: 200, height: 200 });

    // eslint-disable-next-line react/jsx-no-constructed-context-values
    const listenerState = { listeners, attributes, setActivatorNodeRef };

    const sortableStyle = {
        ...style,
        transform: CSS.Transform.toString(transform),
        transition,
        height: size.height,
        width: size.width,
    };

    const mergedRef = (element: HTMLElement | null) => {
        setNodeRef(element);
        if (typeof ref === "function") {
            ref(element);
        } else if (ref) {
            // eslint-disable-next-line no-param-reassign
            ref.current = element;
        }
    };

    const refSetter = Object.create({}, {
        current: {
            set: (element: HTMLElement | null) => {
                mergedRef(element);
            },
        },
    });

    const listenerExpand = shouldDragWholeElement ? { ...listeners, ...attributes } : {};
    const element = (
        <Resizable
            {...rest}
            key={item.id}
            width={size.width}
            height={size.height}
            onResize={(__, value) => {
                setSize(value.size);
            }}
            ref={() => {
                // nope
            }}
            resizeHandles={[direction]}
            handle={<ResizeHandle direction={direction} />}
            className={className}

            // ref={mergedRef}
        >
            <div
                style={sortableStyle}
                ref={refSetter}
                {...rest}
                {...listenerExpand}
            >
                {children}
            </div>

        </Resizable>
    );

    return shouldDragWholeElement ? element : (
        <SortableItemStateContext.Provider value={listenerState}>
            {element}
        </SortableItemStateContext.Provider>
    );
});

SortableResizableItem.defaultProps = {
    shouldDragWholeElement: true,
    isEnabled: true,
};

export default SortableResizableItem;
